import en from "./en";
import ka from "./ka";

export { en, ka };

export const translations = {
  en,
  ka,
} as const;

export type Language = 'en' | 'ka';

// Helper function to get translated category label using global translations
export const getCategoryLabel = (value: string, language: Language): string => {
  const translations = language === 'ka' ? ka : en;
  
  // Map database category values to translation keys
  const categoryKeyMap: Record<string, keyof typeof translations.categories> = {
    'Cleaning Supplies': 'cleaningSupplies',
    'Kitchen Items': 'kitchenItems',
    'Bathroom Products': 'bathroomProducts',
    'Home Decor': 'homeDecor',
    'Storage & Organization': 'storageOrganization',
    'Textiles': 'textiles',
    'Small Appliances': 'smallAppliances',
    'Tools & Hardware': 'toolsHardware',
    'Other': 'other',
    // Additional database categories mapped to existing or new keys
    'Household Goods': 'householdGoods',
    'Clothing & Fashion': 'clothingFashion',
    'Electronics': 'electronics',
    'Food & Restaurant': 'foodRestaurant',
    'Pharmacy & Medical': 'pharmacyMedical',
    'Retail & General': 'retailGeneral',
    // Actual database categories
    'B2B': 'b2b',
    'Clothing': 'clothing',
    'Electronics & Appliances': 'electronicsAppliances',
    'Food': 'food',
    'Sporting Goods': 'sportingGoods',
  };
  
  const key = categoryKeyMap[value];
  if (key && translations.categories[key as keyof typeof translations.categories]) {
    return translations.categories[key as keyof typeof translations.categories];
  }
  
  // Return the original value if no translation found
  return value;
};

// Helper function to get translated source label
export const getSourceLabel = (value: string, language: Language): string => {
  const sourceMap: Record<string, string> = {
    'Viber': 'Viber',
    'WhatsApp': 'WhatsApp',
    'Telegram': 'Telegram',
    'Manual': language === 'ka' ? 'ხელით' : 'Manual',
    'Facebook Messenger': 'Facebook Messenger',
    'Instagram': 'Instagram',
    'External': language === 'ka' ? 'გარე' : 'External',
  };
  
  return sourceMap[value] || value;
};

// Helper function to get translated status label
export const getStatusLabel = (value: string, language: Language): string => {
  const statusMap: Record<string, string> = {
    'New': language === 'ka' ? 'ახალი' : 'New',
    'Processing': language === 'ka' ? 'მუშავდება' : 'Processing',
    'Awaiting Payment': language === 'ka' ? 'გადახდის მოლოდინში' : 'Awaiting Payment',
    'Completed': language === 'ka' ? 'დასრულებული' : 'Completed',
    'Out for Delivery': language === 'ka' ? 'მიტანის პროცესში' : 'Out for Delivery',
    'Delivered': language === 'ka' ? 'მიტანილი' : 'Delivered',
    'Delivery Failed': language === 'ka' ? 'მიტანა ვერ მოხერხდა' : 'Delivery Failed',
    'Cancelled': language === 'ka' ? 'გაუქმებული' : 'Cancelled',
  };
  
  return statusMap[value] || value;
};
